import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { StringParam, useQueryParam } from 'use-query-params';
import { Divider, Tab, Tabs } from '@material-ui/core';
import { Panel, PanelContent } from '@sierralabs/core-ui';
import EntityFieldList from '../tabs/EntityFieldList';
import EntityRelationshipList from '../tabs/EntityRelationshipList';
import { useEntityContext } from '../EntityContext';
import { useEffect } from 'react';
import EntityDataList from '../tabs/EntityDataList';
import { AppSnackbar } from '@sierralabs/core-ui';
import EntityRuleList from '../tabs/EntityRuleList';
const StyledPanel = styled(Panel) ``;
const EntityEditPanel = () => {
    const history = useHistory();
    const [tab, setTab] = useQueryParam('tab', StringParam);
    useEffect(() => void (!tab && setTab('fields')), []);
    const { selectedEntity, updateError } = useEntityContext();
    return (React.createElement(StyledPanel, { className: 'entity-edit-panel' },
        React.createElement(Tabs, { indicatorColor: 'primary', value: tab || 'fields' },
            React.createElement(Tab, { component: Link, label: 'Fields', value: 'fields', to: '?tab=fields' }),
            React.createElement(Tab, { component: Link, label: 'Rules', value: 'rules', to: '?tab=rules' }),
            React.createElement(Tab, { component: Link, label: 'Relationships', value: 'relationships', to: '?tab=relationships' }),
            React.createElement(Tab, { component: Link, label: 'Data', value: 'data', to: '?tab=data' })),
        React.createElement(Divider, null),
        React.createElement(PanelContent, null, (() => {
            switch (tab) {
                case 'fields':
                    return selectedEntity ? (React.createElement(EntityFieldList, { entity: selectedEntity })) : null;
                case 'rules':
                    return selectedEntity ? (React.createElement(EntityRuleList, { entity: selectedEntity })) : null;
                case 'indexes':
                    return React.createElement(React.Fragment, null);
                case 'relationships':
                    return selectedEntity ? (React.createElement(EntityRelationshipList, { entity: selectedEntity })) : null;
                case 'data':
                    return selectedEntity ? (React.createElement(EntityDataList, { entity: selectedEntity })) : null;
            }
        })()),
        updateError && (React.createElement(AppSnackbar, { open: true, severity: 'error' }, updateError.message))));
};
export default EntityEditPanel;
//# sourceMappingURL=EntityEditPanel.js.map